import { Trans } from '@lingui/react/macro';

import type { ZuubCategoryLimitations } from '@/@types/zuub/contracts';

interface CategoryLimitationsListProps {
  categories: ZuubCategoryLimitations[];
}

export const CategoryLimitationsList = ({
  categories,
}: CategoryLimitationsListProps) => {
  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="vai-space-y-6">
      <h3 className="vai-text-lg vai-font-semibold vai-text-foreground">
        <Trans>Service Limitations</Trans>
      </h3>

      {categories.map((category) => (
        <div key={category.categoryName} className="vai-space-y-3">
          <h4 className="vai-text-base vai-font-medium vai-text-foreground">
            {category.categoryName}
          </h4>

          <div className="vai-space-y-4">
            {category.limitations.map((limitation, limitationIndex) => (
              <div
                key={`${limitation.procedureCode}-${limitationIndex}`}
                className="vai-flex vai-items-start vai-gap-3"
              >
                <div className="vai-flex-shrink-0">
                  <span className="vai-inline-flex vai-items-center vai-px-2 vai-py-1 vai-font-medium vai-bg-gray-500 vai-text-white vai-rounded-full">
                    {limitation.procedureCode}
                  </span>
                </div>
                <div className="vai-flex-1 vai-min-w-0">
                  <div className="vai-text-sm vai-text-foreground vai-mt-1">
                    {limitation.limitation}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
